import { render } from "./MessageFooter.vue.js?vue&type=template&id=650f4d2d&scoped=true!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MessageFooter.vue?vue&type=template&id=650f4d2d&scoped=true"
import script from "./MessageFooter.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MessageFooter.vue?vue&type=script&lang=js"
export * from "./MessageFooter.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MessageFooter.vue?vue&type=script&lang=js"

import "./MessageFooter.vue.scss?vue&type=style&index=0&id=650f4d2d&lang=scss&scoped=true!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MessageFooter.vue?vue&type=style&index=0&id=650f4d2d&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-650f4d2d"],['__file',"src/SharedWeb/scripts/apps/conversations/components/message/MessageFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "650f4d2d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('650f4d2d', __exports__)) {
    api.reload('650f4d2d', __exports__)
  }
  
  module.hot.accept("./MessageFooter.vue.js?vue&type=template&id=650f4d2d&scoped=true!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MessageFooter.vue?vue&type=template&id=650f4d2d&scoped=true", () => {
    api.rerender('650f4d2d', render)
  })

}


export default __exports__